import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { GiftSelector } from './components/GiftSelector'
import { StoreAvailability } from './components/StoreAvailability'
import { useSelector, useDispatch } from 'react-redux'
import {
    fetchAvailability,
    fetchTPKGoodiesData,
    searchAllRestaurants
} from 'shared/store/tu-preferes-king'
import { RestaurantSelector } from './components/RestaurantSelector'
import type { TPKState } from 'shared/store/tu-preferes-king'
import type { RootState } from 'shared/store/reducers'
import { useIntl } from 'react-intl'
import { breakpoints } from 'app/assets/styles'
import { H1, Text } from 'app/common/typography'
import { TPKLayout } from '../components/TPKLayout'
import { colors, fonts } from 'app-v2/design-systems'
import { BORDER, SPACING } from 'app-v2/design-tokens'

export function TuPreferesKingGoodiesGain() {
    const state: TPKState = useSelector((s: RootState) => s.tuPreferesKingState)

    const dispatch = useDispatch()

    const intl = useIntl()

    const [width, setWidth] = useState(window.innerWidth)
    const isSmallScreen = width < breakpoints.xsmallLegacy

    useEffect(() => {
        return window.addEventListener('resize', updateWindowDimensions)
    }, [])

    const updateWindowDimensions = () => setWidth(window.innerWidth)

    useEffect(() => {
        dispatch(fetchTPKGoodiesData())
        dispatch(searchAllRestaurants())
    }, [dispatch])

    const [goodies, setGoodies] = useState([])
    const [restaurants, setRestaurants] = useState([])
    const [selectedGoodie, setSelectedGoodie] = useState({
        id: -1,
        name: ''
    })
    const [selectedRestaurant, setSelectedRestaurant] = useState({
        name: '',
        frNumber: ''
    })
    const [loading, setLoading] = useState(false)

    const [isGoodiesMenuOpen, setIsGoodiesMenuOpen] = useState(false)
    const [isResearchMenuOpen, setIsReseachMenuOpen] = useState(false)

    useEffect(() => {
        setGoodies(state.goodies)
        setRestaurants(state.restaurantsData)
    }, [state])

    useEffect(() => {
        if (selectedGoodie.id >= 0 && selectedRestaurant.frNumber) {
            setLoading(true)
            dispatch(
                fetchAvailability(
                    selectedRestaurant.frNumber,
                    selectedGoodie.id
                )
            ).then(() => {
                setLoading(false)
            })
        }
    }, [selectedGoodie, selectedRestaurant])

    return (
        <TPKLayout
            largeContainer
            header={{
                mediumBackground: true,
                withBuoy: true,
                withSurf: true
            }}>
            <StyledContentContainer isSmallScreen={isSmallScreen}>
                <StyledMainTitleContainer>
                    <H1 color={colors.white} font={fonts.flameBold}>
                        {intl.formatMessage({
                            id: 'tupreferesking.goodies.mainTitle'
                        })}
                    </H1>
                </StyledMainTitleContainer>
                <StyledCard isSmallScreen={isSmallScreen}>
                    <StyledTitleContainer>
                        <Text size={SPACING.M} font={fonts.flameRegular}>
                            {intl.formatMessage({
                                id: 'tupreferesking.goodies.explainBlockTitle'
                            })}
                        </Text>
                    </StyledTitleContainer>

                    <StyledChooseGainContainer isSmallScreen={isSmallScreen}>
                        <GiftSelector
                            goodies={goodies}
                            setGoodie={setSelectedGoodie}
                            isMenuOpen={isGoodiesMenuOpen}
                            setIsMenuOpen={setIsGoodiesMenuOpen}
                            setIsOtherMenuOpen={setIsReseachMenuOpen}
                        />
                        <RestaurantSelector
                            restaurants={restaurants}
                            setRestaurant={setSelectedRestaurant}
                            isMenuOpen={isResearchMenuOpen}
                            setIsMenuOpen={setIsReseachMenuOpen}
                            setIsOtherMenuOpen={setIsGoodiesMenuOpen}
                            isSmallScreen={isSmallScreen}
                        />
                    </StyledChooseGainContainer>
                </StyledCard>

                <StoreAvailability
                    loading={loading}
                    restaurantName={selectedRestaurant.name}
                />
            </StyledContentContainer>
        </TPKLayout>
    )
}

const StyledContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: ${({ isSmallScreen }) => (isSmallScreen ? '-200px' : '-220px')};
    align-items: center;
    padding: ${SPACING.L};
`

const StyledMainTitleContainer = styled.div`
    text-align: center;
`

const StyledCard = styled.div`
    background-color: ${colors.white};
    width: 100%;
    min-width: 50%;
    min-height: 100%;
    border-radius: ${BORDER.RADIUS.M};
    margin: ${({ isSmallScreen }) => (isSmallScreen ? '50px' : '90px')}
        ${SPACING.XXXL} ${SPACING.M};
    padding: ${SPACING.L};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

const StyledTitleContainer = styled.div`
    text-align: center;
    padding: ${SPACING.XL} ${SPACING.L} ${SPACING.XXS};
`

const StyledChooseGainContainer = styled.div`
    display: flex;
    flex-direction: ${props => (props.isSmallScreen ? 'column' : 'row')};
    margin: ${SPACING.L} 0
        ${props => (props.isSmallScreen ? SPACING.NONE : SPACING.XL)};
    max-height: 100%;
    width: ${props => (props.isSmallScreen ? '100%' : '90%')};
    gap: ${SPACING.S};
`
